/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './GvaCheckbox.scss';

import noop from 'lodash/noop';
import { bool, func, string } from 'prop-types';
import React from 'react';

const Checkbox = ({
                    checked,
                    label,
                    name,
                    onChange,
                    disabled,
                  }) => {

  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
      <input
        className="gva-checkbox"
        type="checkbox"
        id={name}
        name={name}
        value={name}
        aria-label={label}
        checked={checked}
        onChange={disabled ? noop : handleChange}
      />
  );
};

Checkbox.propTypes = {
  checked: bool.isRequired,
  className: string.isRequired,
  name: string.isRequired,
  label: string.isRequired,
  onChange: func.isRequired,
  disabled: bool.isRequired,
};

Checkbox.defaultProps = {
  className: '',
  label: '',
  onChange: noop,
  disabled: false,
};

export default Checkbox;
